import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useTabTrap } from 'foundation/js/useTabTrap'
import PrimaryLink from './subcomponents/PrimaryLink'
import SecondaryLink from './subcomponents/SecondaryLink'
import GetLabel from 'foundation/js/getLabel'

export default {
    name: 'BurgerMenu',
    components: { PrimaryLink, SecondaryLink },
    setup() {
        const store = useStore()
        const burgerMenuRef = ref(null)
        const linkData = computed(() => store.state.main.burger_menu_links)
        const showFunctionalButtons = false

        const { tabTrap } = useTabTrap(burgerMenuRef)

        let isSimple = document.querySelector('nav.kb-component--burger-menu') ?.hasAttribute('is-simple')
        let isIndependent = document.querySelector('body').classList.contains('kb-independent-site')
        let showReturnLink = document.querySelector('nav.kb-component--burger-menu')?.hasAttribute('show-return-link')


        return {
            burgerMenuRef,
            linkData,
            tabTrap,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'burgerMenu' }),
            showFunctionalButtons,
            isSimple,
            isIndependent,
            showReturnLink
        }
    }
}
